import { IconButton, IconButtonProps } from "@chakra-ui/react";
import { SvgIcon } from "components/SvgIcon";

interface Props extends Partial<Omit<IconButtonProps, "icon">> {
  icon?: string;
  isDisabled?: boolean;
}

const ButtonPlus = ({
  icon = "/img/icon-plus.svg",
  isDisabled = false,
  ...restProps
}: Props) => {
  return (
    <IconButton
      aria-label="icon-plus"
      p="1.1rem"
      ml="auto"
      variant="outline"
      icon={<SvgIcon src={icon} width="1.6rem" height="1.6rem" />}
      isDisabled={isDisabled}
      {...restProps}
    />
  );
};

export default ButtonPlus;
